/**
 * "Back to sign in": the way out of every signed-out auth screen.
 *
 * DESIGN GATE B2 (grader round 11, desk pass 5, row DESIGN-auth-recovery).
 * /auth/recovery, signed out, at 1280 and at 375, had exactly one link on it:
 * the Elreign logo, which goes to the marketing site. The affordance existed
 * one click deeper, on /auth/forgot, as a block of inline markup. Checking every
 * other signed-out auth screen found three more with no way back at all:
 * /auth/recovery/lost-both (both of its views), /auth/recovery/status, and
 * /auth/check-email after a reset request.
 *
 * So the markup /auth/forgot already shipped is lifted here unchanged (the same
 * rule above it, the same type, the same link colour and weight, the same
 * words) and every one of those screens renders this instead of a copy.
 *
 * `prompt` is the lead-in sentence and belongs to the screen, because what the
 * reader "remembered" differs: a password on /auth/forgot, a device on
 * /auth/recovery. Where no lead-in is true for everyone who lands (the Tier 3
 * form, the status lookup), there is none, and the link stands alone.
 *
 * No `next` is carried: /auth/forgot never took one, and none of these screens
 * is given one to preserve.
 */

import { Link } from '@tanstack/react-router';

export function BackToSignIn({ prompt }: { prompt?: string }) {
  return (
    <div
      style={{
        marginTop: 24,
        paddingTop: 18,
        borderTop: '1px solid var(--hairline)',
        fontSize: 13.5,
        color: 'var(--ink-3)',
        lineHeight: 1.6,
      }}
    >
      {prompt ? <>{prompt} </> : null}
      <Link
        to="/auth/login"
        style={{ color: 'var(--primary-600)', fontWeight: 500 }}
      >
        Back to sign in
      </Link>
      .
    </div>
  );
}
